
<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title v-if="!drawer">{{ pageTitle }}</v-toolbar-title>
                <v-spacer v-if="!drawer"></v-spacer>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-if="!drawer"
                    >
                        <v-icon dark>mdi-menu</v-icon>
                </v-btn>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-else
                    large min-width="100%"
                    >
                        <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)">
          <v-data-table
            :headers="headers"
            :items="issues"
            sort-by="id"
            class="elevation-1 dark-last-row"
            hide-default-footer
            item-key="id"
            :loading="loading"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="#004889"
              >
                <!--<v-toolbar-title class="white--text">Issues</v-toolbar-title>-->
                <v-spacer></v-spacer>
                <v-dialog
                  v-model="dialog"
                  max-width="500px"
                  scrollable
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      tile
                      small
                    >
                      <v-icon dark>mdi-plus</v-icon>
                      Add
                    </v-btn>
                  </template>
                  <v-card flat color="#004889">
                    <v-card-title class="accent">
                      <span class="title text-uppercase white--text">{{ formTitle }}</span>
                    </v-card-title>

                  <v-card-text class="pa-0">
                      <ValidationObserver ref="observer1">
                        <v-form ref="warrantyform">
                          <v-list-item class="form-row"> 
                              <v-list-item-content class="label">
                                  <v-list-item-title class="white--text font-weight-bold">Job</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                  <ValidationProvider v-slot="{ errors }" name="Job" rules="required">
                                  <v-autocomplete
                                      v-model="editedItem.job"
                                      :items="jobs"
                                      item-text="title"
                                      item-value="id"
                                      label="Job"
                                      :error-messages="errors"
                                      required
                                      solo
                                      flat
                                      dark
                                      return-object
                                  ></v-autocomplete>
                                  </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list flat color="#004889" class="py-0">
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Issue</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <ValidationProvider v-slot="{ errors }" name="Issue" rules="required">
                                      <v-text-field
                                        v-model="editedItem.issue"
                                        label="Issue"
                                        :error-messages="errors"
                                        required
                                        solo
                                        flat
                                        dark
                                      ></v-text-field>
                                    </ValidationProvider>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Description</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <ValidationProvider v-slot="{ errors }" name="Description" rules="required">
                                      <v-textarea
                                        v-model="editedItem.description"
                                        label="Description"
                                        :error-messages="errors"
                                        required
                                        solo
                                        flat
                                        dark
                                      ></v-textarea>
                                    </ValidationProvider>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                                    <v-select
                                        v-model="editedItem.status"
                                        :items="statuses"
                                        item-text="label"
                                        item-value="value"
                                        label="Status"
                                        required
                                        :error-messages="errors"
                                        solo
                                        flat
                                        dark
                                    ></v-select>
                                  </ValidationProvider>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Deadline</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-menu
                                      v-model="menu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                  >
                                      <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                          v-model="computedDeadlineFormatted"
                                          label="Deadline"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                          solo
                                          flat
                                          dark
                                          clearable
                                      ></v-text-field>
                                      </template>
                                      <v-date-picker
                                      v-model="editedItem.deadline"
                                      @input="menu = false"
                                      ></v-date-picker>
                                  </v-menu>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Assignee</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-select
                                        v-model="editedItem.assignee"
                                        :items="users"
                                        item-text="name"
                                        item-value="id"
                                        label="Assignee"
                                        clearable
                                        solo
                                        flat
                                        dark
                                    ></v-select>
                                </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-form>
                      </ValidationObserver>
                    </v-card-text>
                    <v-card-actions class="accent">
                      <v-btn
                        large min-width="49%" color="white" text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        large min-width="49%" color="primary" tile
                        @click="save"
                        :loading="loading"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card color="red">
                    <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
                    <v-card-actions class="red darken-4">
                      <v-spacer></v-spacer>
                      <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="props">
              <v-btn large min-width="50%" color="primary" tile @click="editItem(props.item)">      
                <v-icon
                >
                  mdi-pencil
                </v-icon>
              </v-btn>             
              <v-btn large min-width="50%" color="red" tile @click="deleteItem(props.item.id)">
                <v-icon
                color="white"
                >
                mdi-delete
              </v-icon>  
              </v-btn>  
            </template>
            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="getEquipment"
                tile
                :loading="loading"
              >
                No Items Found. Click Here to Refresh!
              </v-btn>
            </template>
            <template v-slot:item.issue="props">
              <v-edit-dialog
                :return-value.sync="props.item.issue"
                @save="saveField(props.item.id)"
                large
              >
                {{ props.item.issue }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.issue"
                    label="Edit"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:item.status="props">
              <v-edit-dialog
                :return-value.sync="props.item.status"
                @save="saveField(props.item.id)"
                large
              >
                <v-chip
                  color="green"
                  text-color="white"
                  v-if="props.item.status == 'resolved'"
                >
                  Resolved
                </v-chip>
                <v-chip
                  color="primary"
                  text-color="white"
                  v-else-if="props.item.status == 'pending'"
                >
                  Pending
                </v-chip>
                <v-chip
                  color="orange"
                  text-color="white"
                  v-else-if="props.item.status == 'in_progress'"
                >
                  In Progress
                </v-chip>
                <v-chip
                  color="red"
                  text-color="white"
                  v-else-if="props.item.status == 'cancelled'"
                >
                  Cancelled
                </v-chip>
                <template v-slot:input>
                  <v-select
                      v-model="props.item.status"
                      :items="statuses"
                      item-text="label"
                      item-value="value"
                      label="Status"
                  ></v-select>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:item.assignee="props">
              <v-edit-dialog
                :return-value.sync="props.item.assignee"
                @save="saveField(props.item.id)"
                large
              >
                {{ getUsername(props.item.assignee) }}
                <template v-slot:input>
                  <v-select
                      v-model="props.item.assignee"
                      :items="users"
                      item-text="name"
                      item-value="id"
                      label="Assignee"
                  ></v-select>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:item.job="props">
              <router-link
                :to="`/job/main/${props.item.job.id}`"
              >
                <NavLink>{{ props.item.job.job_no }}</NavLink>
              </router-link>
            </template>
            <template v-slot:item.deadline="props">
              <v-edit-dialog
                :return-value.sync="props.item.deadline"
                @save="saveField(props.item.id)"
                large
              >
                {{ formatDate(props.item.deadline) }}
                <template v-slot:input>

                  <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="props.item.deadline"
                          label="Deadline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                      </template>
                      <v-date-picker
                      v-model="props.item.deadline"
                      @input="menu = false"
                      ></v-date-picker>
                  </v-menu>
                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
    import TokenService from '../services/storage.service'
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import mixin from '../mixin/main.js'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin],
        data: () => ({
            loading: false,
            token: '',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Job', value: 'job', sortable: true },
                {
                  text: 'Issue',
                  align: 'start',
                  sortable: false,
                  value: 'issue',
                },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'Deadline', value: 'deadline', sortable: false },
                { text: 'Assignee', value: 'assignee', sortable: false },
                { text: 'Description', value: 'description', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false, align: 'right' },
            ],
            issues: [],
            jobs: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                issue: '',
                status: 'pending',
                deadline: '',
                assignee: '',
                description: '',
            },
            defaultItem: {
                id: '',
                issue: '',
                status: 'pending',
                deadline: '',
                assignee: '',
                description: '',
            },
            statuses: [
                { label: 'Resolved', value: 'resolved' },
                { label: 'In Progress', value: 'in_progress' },
                { label: 'Pending', value: 'pending' },
                { label: 'Cancelled', value: 'cancelled' },
            ],
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Issue' : 'Edit Issue'
            },
            computedDeadlineFormatted () {
                return this.formatDate(this.editedItem.deadline)
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
            this.getIssues()
        },

        methods: {
            getIssues() {
                this.loading = true
                axios.get('crm/job/issues/get')
                    .then(response => {
                        this.loading = false
                        this.issues = response.data.issues
                        this.jobs = response.data.jobs
                        this.$nextTick()
                    })
            },

            editItem (item) {
                this.editedIndex = this.issues.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.issues.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('crm/job/issue/delete?id=' + this.editedIndex)
                    .then(() => {
                      this.closeDelete()
                      this.getIssues()
                      this.$nextTick()
                    })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/job/issue/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getIssues()
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      this.$set(this.editedItem, 'job', this.editedItem.job.id)
                      axios.post('crm/job/issue/add', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getIssues()
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },

            saveField(id) {
              let item = this.issues.filter(issue => {
                return issue.id == id
              })

              if(item.length) {
                axios.post('crm/job/issue/update', item[0]).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.getIssues()
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })     
              } 
            },
        },
    }
</script>